import makeApi from 'client/api'
import blankImage from '../assets/blankScreen.png'
import Boom from 'boom'

const uploadBlankImage = async (token, announcementId) => {
  const url = `/announcements/properties/${announcementId}/images?index=0`
  const form = new FormData()

  var image = new File([blankImage], 'image.txt')

  form.append('image', image)

  try {
    await fetch(`${process.env.REACT_APP_WEB_API}${url}`, {
      method: 'POST',
      body: form,
      headers: { Authorization: `Bearer ${token}` },
    })
  } catch (err) {
    console.log({ err })
  }
}

export const announceProperty = async (property, token) => {
  const { api } = makeApi({ token })

  const { ok, data, status } = await api.post('/announcements/properties', property)

  if (!ok) {
    if (status === 404) {
      throw Boom.notFound('Entity not found')
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }
  console.log({ data: data })
  try {
    await uploadBlankImage(token, data.data.id)
  } catch (err) {
    throw new Error(err.message)
  }

  return data
}
